import { ChangeEventHandler, FocusEventHandler } from 'react';

import { RequestStatus } from 'shared/constants/State';
import { PERSON_KIND } from './constants';

export interface Clinic {
  address: string;
  number: string;
  complement: string;
  neighborhood: string;
  city: string;
  state: string;
  zip_code: string;
  clinic_cnpj: string;
  clinic_as_billing?: boolean;
}
export interface Professional {
  [key: string]: unknown;
  rqe: string;
  council_name: string;
  council_number: string;
  council_region: string;
  cbo: number;
  profile: {
    cpf: string;
    professional_cnpj: string;
  };
}

export interface ClinicBillingType {
  person_kind: typeof PERSON_KIND[keyof typeof PERSON_KIND];
  responsible: string;
  cpf_cnpj: string;
  billing_address: string;
  billing_number: number | string;
  billing_address2: string;
  billing_neighborhood: string;
  billing_city: string;
  billing_state: string;
  billing_zip: string;
  billing_country: string;
  billing_birthdate?: string;
}
export interface CFMUpdatePayload {
  clinic: Clinic | null;
  clinicBilling: ClinicBillingType | null;
  professional: Professional | null;
}

export enum CFMUpdateSteps {
  none = '',
  start = 'start',
  clinic = 'clinic',
  clinicBilling = 'clinicBilling',
  professional = 'professional',
  done = 'done',
  close = 'close',
}

export interface CFMUpdateState extends CFMUpdatePayload {
  steps: Record<string, JSX.Element> | null;
  step: CFMUpdateSteps;
  isAlertVisible: boolean;
  status: RequestStatus;
  clinicUpdateDone: boolean;
  professionalUpdateDone: boolean;
  clinicBillingUpdateDone: boolean;
  error: string;
  possibleSteps: string[];
}

export interface UpdateStepProps {
  onClose?: () => void;
  showCloseButton?: boolean;
}

export interface FormStepContainerProps extends UpdateStepProps {
  title: React.ReactNode;
  children: React.ReactNode;
}

export interface SelectProps {
  handleChange: ChangeEventHandler;
  error: boolean;
  value: string | number;
  disabled: boolean;
  helperText?: string | boolean;
  handleBlur?: FocusEventHandler;
}

export interface StateSelectProps extends SelectProps {
  name: string;
  label: string;
}

export interface ProfessionalFormValues {
  cpf: string;
  rqe: string;
  council_name: string;
  council_number: string;
  council_region: string;
  cbo: string;
  professional_cnpj: string;
}

export interface ProfessionalPayload
  extends Omit<ProfessionalFormValues, 'cbo'> {
  cbo: number | string;
}

export interface ClinicFormValues extends Omit<Clinic, 'number'> {
  number: string;
}

export interface ClinicBillingFormValues
  extends Omit<ClinicBillingType, 'number'> {
  number: string;
}

export type UpdateClinicService = (
  clinicId: string,
  values: ClinicFormValues,
) => Promise<unknown>;
